import React from 'react';


// Static presentation header for the login page. Injects the page-level
// styling (Orisha brand gradient background + card look). No auth logic here.
function Header({ titleHeader }) {
  return (
    <header>
      <title>Documentation API</title>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" type="image/jpg" href="./favicon.jpg" />
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap"
        rel="stylesheet"
      />
      <style>
        {`
          :root {
            --orisha-dark: #333333;
            --orisha-purple: #462383;
            --orisha-purple-light: #6b40a3;
            --orisha-magenta: #e8005f;
            --orisha-orange: #ff7a00;
            --orisha-yellow: #feb702;
            --orisha-white: #ffffff;
            --orisha-light-gray: #f7f7f7;
          }

          html, body {
            margin: 0;
            padding: 0;
            min-height: 100vh;
            font-family: 'Poppins', sans-serif;
            /* Orisha group brand gradient: deep purple -> magenta -> orange */
            background: linear-gradient(
              135deg,
              #462383 0%,
              #6b40a3 28%,
              #e8005f 68%,
              #ff7a00 100%
            );
            background-attachment: fixed;
          }

          .min-height {
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 24px 16px;
            box-sizing: border-box;
          }

          .title-header {
            color: var(--orisha-white);
            text-align: center;
            font-size: 32px;
            font-weight: 600;
            letter-spacing: 0.5px;
            margin: 0 0 28px 0;
            text-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
          }

          h1 {
            font-family: 'Poppins', sans-serif;
          }

          a {
            text-decoration: none;
            color: var(--orisha-purple);
            transition: color 0.2s ease;
          }
          a:hover {
            color: var(--orisha-purple-light);
          }
        `}
      </style>
      <h1 className="title-header">{titleHeader}</h1>
    </header>
  );
}

export default Header;
